import { SpentTimeRecorder } from '@features/spent-time';
import { MasterLayout } from 'components/Layout/Master';
import { AuthContainer } from 'features/auth/AuthContainer';
import { AccessDeniedPage } from 'pages/AccessDeniedPage';
import { CatalogConstructionTypes } from 'pages/Catalogs/CatalogConstructionTypes';
import { CatalogList } from 'pages/Catalogs/CatalogList';
import { CatalogOtherCostsLimitedCosts } from 'pages/Catalogs/CatalogOtherCostsLimitedCosts';
import { CatalogRatios } from 'pages/Catalogs/CatalogRatios';
import { CatalogTypesWork } from 'pages/Catalogs/CatalogTypesWork';
import { CatalogUER } from 'pages/Catalogs/CatalogUERBaseCost';
import { CatalogUerOtherCostTemplates } from 'pages/Catalogs/CatalogUerOtherCostTemplates';
import { CatalogVariablesOther } from 'pages/Catalogs/CatalogVariablesOther';
import { CatalogVariablesOtherBIM } from 'pages/Catalogs/CatalogVariablesOtherBIM';
import { CatalogVariablesOtherUer } from 'pages/Catalogs/CatalogVariablesOtherUer';
import { DockableModal } from 'pages/Playground/DockableModal/DockableModal';
import { FormulaEditorSample } from 'pages/Playground/FormulaEditorSample';
import { SearchableSelectTestPage } from 'pages/Playground/SearchableSelect/SearchableSelect';
import { TableLikeTreeTestPage } from 'pages/Playground/TableLikeTree/TableLikeTree';
import { Profile } from 'pages/Profile';
import { BimCalculationLimited } from 'pages/Project/BimProject/BimCalculation/BimCalculationLimited';
import { BimCalculationLocalEstimate } from 'pages/Project/BimProject/BimCalculation/BimCalculationLocalEstimate';
import { BimCalculationOthers } from 'pages/Project/BimProject/BimCalculation/BimCalculationOthers';
import { BimCalculationPreview } from 'pages/Project/BimProject/BimCalculation/BimCalculationPreview';
import { BimCalculationRead } from 'pages/Project/BimProject/BimCalculation/BimCalculationRead';
import { BimCalculationStructure } from 'pages/Project/BimProject/BimCalculation/BimCalculationStructure';
import { BimCalculationUpdate } from 'pages/Project/BimProject/BimCalculation/BimCalculationUpdate';
import { BimContractEdit } from 'pages/Project/BimProject/Contract/BimContractEdit';
import { BimContractRead } from 'pages/Project/BimProject/Contract/BimContractRead';
import { BimContractStructure } from 'pages/Project/BimProject/Contract/BimContractStructure';
import { BimWorkOrder } from 'pages/Project/BimProject/WorkOrder/BimWorkOrder';
import { BimWorkOrderActsKc2List } from 'pages/Project/BimProject/WorkOrder/BimWorkOrderActsKc2List';
import { BimWorkOrderStructure } from 'pages/Project/BimProject/WorkOrder/BimWorkOrderStructure';
import { BimWorkOrderChange } from 'pages/Project/BimProject/WorkOrderChange/BimWorkOrderChange';
import { BimWorkOrderChangeStructure } from 'pages/Project/BimProject/WorkOrderChange/bimWorkOrderChangeStructure/bimWorkOrderChangeStructure';
import { BimWorkOrderVersion } from 'pages/Project/BimProject/WorkOrderVersion';
import { BimVersionViewStructure } from 'pages/Project/BimProject/WorkOrderVersion/BimVersionViewStructure/BimVersionViewStructure';
import { ProjectCreate, ProjectList } from 'pages/Project/Common';
import { ContractOthers } from 'pages/Project/Common/Contract/Others/ContractOthers';
import { PageLayoutContextProvider } from 'pages/Project/Common/Layouts/PageLayoutContext';
import { ProjectRead } from 'pages/Project/Common/ProjectRead';
import { ProjectUpdate } from 'pages/Project/Common/ProjectUpdate';
import { ActKC3List } from 'pages/Project/UerProject/ActKC3List';
import { AgreementForm } from 'pages/Project/UerProject/AgreementsRegistry/AgreementForm';
import { AgreementsRegistry } from 'pages/Project/UerProject/AgreementsRegistry/AgreementsRegistry';
import { CalculationLimited } from 'pages/Project/UerProject/Calculation/CalculationLimited';
import { CalculationMtrs } from 'pages/Project/UerProject/Calculation/CalculationMtrs';
import { CalculationOthers } from 'pages/Project/UerProject/Calculation/CalculationOthers';
import { CalculationPreview } from 'pages/Project/UerProject/Calculation/CalculationPreview';
import { CalculationPrices } from 'pages/Project/UerProject/Calculation/CalculationPrices';
import { CalculationRatios } from 'pages/Project/UerProject/Calculation/CalculationRatios';
import { CalculationRead } from 'pages/Project/UerProject/Calculation/CalculationRead';
import { CalculationStructure } from 'pages/Project/UerProject/Calculation/CalculationStructure';
import { CalculationUpdate } from 'pages/Project/UerProject/Calculation/CalculationUpdate';
import { CalculationWorkVolume } from 'pages/Project/UerProject/Calculation/CalculationWorkVolume';
import { ContractRead } from 'pages/Project/UerProject/Contract/ConractRead';
import { UerContractStructure } from 'pages/Project/UerProject/Contract/ContractStructure/UerContractStructure';
import { ContractUpdate } from 'pages/Project/UerProject/Contract/ContractUpdate';
import { ContractUpload } from 'pages/Project/UerProject/Contract/ContractUpload';
import { PriceListFactors } from 'pages/Project/UerProject/PriceList/PriceListFactors/PriceListFactors';
import { PriceListMtr } from 'pages/Project/UerProject/PriceList/PriceListMtr/PriceListMtr';
import { PriceListUER } from 'pages/Project/UerProject/PriceList/PriceListUER/PriceListUER';
import { ReplaceWorkOrder } from 'pages/Project/UerProject/ReplaceWorkOrder';
import { UerWorkOrderActsKc2List } from 'pages/Project/UerProject/WorkOrder/UerWorkOrderActsKc2List';
import { WorkOrder } from 'pages/Project/UerProject/WorkOrder/WorkOrder';
import { WorkOrderNew } from 'pages/Project/UerProject/WorkOrder/WorkOrderNew';
import { UerWorkOrderStructure } from 'pages/Project/UerProject/WorkOrder/WorkOrderStructure/UerWorkOrderStructure';
import { WorkOrderUploadModal } from 'pages/Project/UerProject/WorkOrder/WorkOrderUpload';
import { WorkOrderChange } from 'pages/Project/UerProject/WorkOrderChange/WorkOrderChange';
import { WorkOrderChangeNew } from 'pages/Project/UerProject/WorkOrderChange/WorkOrderChange/WorkOrderChangeNew';
import { UerWorkOrderChangeStructure } from 'pages/Project/UerProject/WorkOrderChange/WorkOrderChangeStructure/UerWorkOrderChangeStructure';
import { WorkOrderVersion, WorkOrderVersionNew } from 'pages/Project/UerProject/WorkOrderVersion';
import { WorkOrderVersionStructure } from 'pages/Project/UerProject/WorkOrderVersionStructure';
import { SystemInformation } from 'pages/SystemInformation';
import { Loader } from 'uikit';

import { Suspense } from 'react';
import { createBrowserRouter, Outlet } from 'react-router-dom';

export const router = createBrowserRouter([
    {
        element: (
            <AuthContainer>
                <SpentTimeRecorder>
                    <PageLayoutContextProvider>
                        <MasterLayout>
                            <Outlet />
                        </MasterLayout>
                    </PageLayoutContextProvider>
                </SpentTimeRecorder>
            </AuthContainer>
        ),
        children: [
            {
                path: '/',
                element: <ProjectList />,
            },
            {
                path: 'projects',
                children: [
                    {
                        index: true,
                        element: <ProjectList />,
                    },
                    { path: 'create', element: <ProjectCreate /> },
                    {
                        path: 'uer/:id',
                        handle: { methodology: 'uer' },
                        children: [
                            {
                                index: true,
                                element: <ProjectRead />,
                                handle: {
                                    analyticsName: 'Карточка проекта',
                                },
                            },
                            { path: 'edit', element: <ProjectUpdate /> },
                            {
                                path: 'calculation',
                                element: (
                                    <Suspense fallback={<Loader size="m" />}>
                                        <Outlet />
                                    </Suspense>
                                ),
                                children: [
                                    {
                                        index: true,
                                        element: <CalculationRead />,
                                        handle: {
                                            analyticsName: 'Карточка расчета НМЦ',
                                        },
                                    },
                                    { path: 'edit', element: <CalculationUpdate /> },
                                    { path: 'edit/:tabId', element: <CalculationUpdate /> },
                                    {
                                        path: 'structure',
                                        element: <CalculationStructure />,
                                        handle: {
                                            analyticsName: 'Структура расчета',
                                        },
                                    },
                                    {
                                        path: 'prices',
                                        element: <CalculationPrices />,
                                        handle: {
                                            analyticsName: 'Сборник расценок',
                                        },
                                    },
                                    {
                                        path: 'ratios',
                                        element: <CalculationRatios />,
                                        handle: {
                                            analyticsName: 'Сборник коэффициентов',
                                        },
                                    },
                                    {
                                        path: 'mtrs',
                                        element: <CalculationMtrs />,
                                        handle: {
                                            analyticsName: 'Ведомость МТР',
                                        },
                                    },
                                    {
                                        path: 'others',
                                        element: <CalculationOthers />,
                                        handle: {
                                            analyticsName: 'Прочие затраты',
                                        },
                                    },
                                    {
                                        path: 'limited',
                                        element: <CalculationLimited />,
                                        handle: {
                                            analyticsName: 'Лимитированные затраты',
                                        },
                                    },
                                    {
                                        path: 'vor',
                                        element: <CalculationWorkVolume />,
                                        handle: { analyticsName: 'ВОР' },
                                    },
                                    {
                                        path: 'preview',
                                        element: <CalculationPreview />,
                                        handle: {
                                            analyticsName: 'Предпросмотр расчета',
                                        },
                                    },
                                ],
                            },
                            {
                                path: 'contract',
                                children: [
                                    { index: true, element: <ContractRead /> },
                                    {
                                        path: 'upload',
                                        element: <ContractUpload />,
                                    },
                                    {
                                        path: 'mtr/*',
                                        element: <PriceListMtr />,
                                    },
                                    {
                                        path: 'factors/*',
                                        element: <PriceListFactors />,
                                    },
                                    {
                                        path: 'prices/*',
                                        element: <PriceListUER />,
                                    },
                                    {
                                        path: 'edit',
                                        element: <ContractUpdate />,
                                    },
                                    {
                                        path: 'edit/:tabId',
                                        element: <ContractUpdate />,
                                    },
                                    {
                                        path: 'agreements',
                                        children: [
                                            {
                                                index: true,
                                                element: <AgreementsRegistry />,
                                            },
                                            {
                                                path: ':agreementId',
                                                element: <AgreementForm />,
                                            },
                                            { path: '*', element: <AccessDeniedPage /> },
                                        ],
                                    },
                                    {
                                        path: 'others',
                                        element: <ContractOthers />,
                                    },
                                    {
                                        path: 'actsKC3',
                                        element: <ActKC3List />,
                                    },
                                    {
                                        path: 'structure',
                                        element: <UerContractStructure />,
                                    },
                                    { path: '*', element: <AccessDeniedPage /> },
                                ],
                            },
                            {
                                path: 'order',
                                children: [
                                    { path: 'upload', element: <WorkOrderUploadModal /> },
                                    { path: ':orderId/structure', element: <UerWorkOrderStructure /> },
                                    { path: ':orderId/actsKC2List', element: <UerWorkOrderActsKc2List /> },
                                    {
                                        path: ':orderId/actsKC2List/:groupType',
                                        element: <UerWorkOrderActsKc2List />,
                                    },
                                    {
                                        path: ':orderId/actsKC2List/:groupType/:subGroup',
                                        element: <UerWorkOrderActsKc2List />,
                                    },
                                    { path: ':orderId/old/*', element: <WorkOrder /> },
                                    { path: ':orderChangeId/replace', element: <ReplaceWorkOrder /> },
                                    { path: ':orderId/*', element: <WorkOrderNew /> },
                                    { path: '*', element: <AccessDeniedPage /> },
                                ],
                            },
                            {
                                path: 'order/:orderId/version/:versionId/structure/*',
                                element: <WorkOrderVersionStructure />,
                            },
                            {
                                path: 'order/:orderId/version/:versionId/*',
                                element: <WorkOrderVersionNew />,
                            },
                            {
                                path: 'order/:orderId/old/version/:versionId/*',
                                element: <WorkOrderVersion />,
                            },
                            {
                                path: 'orderChange',
                                children: [
                                    {
                                        path: ':orderChangeId/structure',
                                        element: <UerWorkOrderChangeStructure />,
                                    },
                                    { path: ':orderChangeId/old/*', element: <WorkOrderChange /> },
                                    { path: ':orderChangeId/*', element: <WorkOrderChangeNew /> },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'bim/:id',
                        handle: {
                            methodology: 'bim',
                        },
                        children: [
                            {
                                index: true,
                                element: <ProjectRead />,
                            },
                            { path: 'edit', element: <ProjectUpdate /> },
                            {
                                path: 'contract',
                                children: [
                                    { index: true, element: <BimContractRead /> },
                                    {
                                        path: 'upload',
                                        element: <BimContractEdit isCreate />,
                                    },
                                    {
                                        path: 'edit',
                                        element: <BimContractEdit />,
                                    },
                                    {
                                        path: 'structure',
                                        element: <BimContractStructure />,
                                    },
                                    {
                                        path: 'others',
                                        element: <ContractOthers />,
                                    },
                                ],
                            },
                            {
                                path: 'calculation',
                                element: (
                                    <Suspense fallback={<Loader size="m" />}>
                                        <Outlet />
                                    </Suspense>
                                ),
                                children: [
                                    {
                                        index: true,
                                        element: <BimCalculationRead />,
                                    },
                                    { path: 'edit', element: <BimCalculationUpdate /> },
                                    { path: 'edit/:tabId', element: <BimCalculationUpdate /> },
                                    { path: 'structure', element: <BimCalculationStructure /> },
                                    { path: 'local-estimate', element: <BimCalculationLocalEstimate /> },
                                    { path: 'preview', element: <BimCalculationPreview /> },
                                    {
                                        path: 'others',
                                        element: <BimCalculationOthers />,
                                        handle: {
                                            analyticsName: 'Прочие затраты',
                                        },
                                    },
                                    {
                                        path: 'limited',
                                        element: <BimCalculationLimited />,
                                    },
                                ],
                            },
                            {
                                path: 'order',
                                children: [
                                    {
                                        path: ':orderId/version/:versionId/structure',
                                        element: <BimVersionViewStructure />,
                                    },
                                    {
                                        path: ':orderId/version/:versionId/*',
                                        element: <BimWorkOrderVersion />,
                                    },
                                    { path: ':orderId/structure', element: <BimWorkOrderStructure /> },
                                    { path: ':orderId/actsKC2List', element: <BimWorkOrderActsKc2List /> },
                                    { path: ':orderId/*', element: <BimWorkOrder /> },
                                    { path: '*', element: <AccessDeniedPage /> },
                                ],
                            },
                            {
                                path: 'orderChange',
                                children: [
                                    {
                                        path: ':orderChangeId/structure/*',
                                        element: <BimWorkOrderChangeStructure />,
                                    },
                                    { path: ':orderChangeId/*', element: <BimWorkOrderChange /> },
                                ],
                            },
                        ],
                    },
                    { path: '*', element: <AccessDeniedPage /> },
                ],
            },
            {
                path: 'catalogs',
                children: [
                    {
                        index: true,
                        element: <CatalogList />,
                    },
                    { path: 'CatalogVariablesOtherBIM/:id', element: <CatalogVariablesOtherBIM /> },
                    { path: 'CatalogVariablesOtherUER/:id', element: <CatalogVariablesOtherUer /> },
                    { path: 'CatalogUER/:id', element: <CatalogUER /> },
                    { path: 'CatalogWorkType/:id', element: <CatalogTypesWork /> },
                    { path: 'CatalogRatios/:id', element: <CatalogRatios /> },
                    { path: 'CatalogUEROtherCostTemplates/:id', element: <CatalogUerOtherCostTemplates /> },
                    { path: 'CatalogOtherCostsLimitedCosts/:id', element: <CatalogOtherCostsLimitedCosts /> },
                    { path: 'CatalogVariablesOther/:id', element: <CatalogVariablesOther /> },
                    { path: 'CatalogConstructionType/:id', element: <CatalogConstructionTypes /> },
                    { path: '*', element: <AccessDeniedPage /> },
                ],
            },
            {
                path: 'profile',
                element: <Profile />,
            },
            {
                path: 'systemInformation',
                element: <SystemInformation />,
            },
            {
                path: 'playground',
                children: [
                    { index: true, element: <TableLikeTreeTestPage /> },
                    { path: 'dockable-modal', element: <DockableModal /> },
                    { path: 'formulaEditor', element: <FormulaEditorSample /> },
                    { path: 'searchable', element: <SearchableSelectTestPage /> },
                ],
            },
            {
                path: '*',
                element: <AccessDeniedPage />,
            },
        ],
    },
]);
